export default __webpack_public_path__ + "static/media/coffee-logo.ee84714e.png";